import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl mt-0 font-bold" }, "Mitarbeiter & Teams", -1)
const _hoisted_2 = { class: "w-full flex justify-between items-start mt-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "calculators",
  class: "text-left font-semibold flex items-center pr-4"
}, "Berechner", -1)
const _hoisted_4 = {
  key: 0,
  id: "calculators",
  class: "flex-col flex gap-2"
}
const _hoisted_5 = {
  key: 1,
  id: "calculators",
  class: "text-right"
}

import LabelAndValueDiv from '@/components/DetailPage/LabelAndValueDiv.vue'
import User from '@/interfaces/User'
import { useSelectedProject } from '@/store/selectedProject'
import { useUsers } from '@/store/users'
import { computed } from '@vue/reactivity'


export default /*#__PURE__*/_defineComponent({
  __name: 'TeamsData',
  setup(__props) {

const selectedProjectStore = useSelectedProject()
const usersStore = useUsers()

const managerUser = computed(() => {
  if(selectedProjectStore.project.manager_user == null) return
  return usersStore.users.find(user => {
    return user.id == selectedProjectStore.project.manager_user
  })
})

const salesUser = computed(() => {
  if(selectedProjectStore.project.sales_user == null) return
  return usersStore.users.find(user => {
    return user.id == selectedProjectStore.project.sales_user
  })
})

const advisorUser = computed(() => {
  if(!selectedProjectStore.project.advisor_user) return
  return usersStore.users.find(user => {
    return user.id == selectedProjectStore.project.advisor_user
  })
})

const calculators = computed(() => {
  const calculators: User[] = []
  for(const userToFind of selectedProjectStore.project.calculators) {
    usersStore.users.find(user => {
      if(user.id === userToFind) {
        calculators.push(user)
      }
    })
  }
  return calculators
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", null, [
      _createVNode(LabelAndValueDiv, {
        label: "Projektleiter",
        value: _unref(managerUser) ? _unref(managerUser).first_name + ', ' + _unref(managerUser).last_name : 'Niemand'
      }, null, 8, ["value"]),
      _createVNode(LabelAndValueDiv, {
        label: "Vertrieb",
        value: _unref(salesUser) ? _unref(salesUser).first_name + ', ' + _unref(salesUser).last_name : 'Niemand'
      }, null, 8, ["value"]),
      _createVNode(LabelAndValueDiv, {
        label: "Sachbearbeiter",
        value: _unref(advisorUser) ? _unref(advisorUser).first_name + ', ' + _unref(advisorUser).last_name : 'Niemand'
      }, null, 8, ["value"]),
      _createVNode(LabelAndValueDiv, {
        label: "Team / Niederlassung",
        value: _unref(selectedProjectStore).project.team.name ? _unref(selectedProjectStore).project.team.name : 'Kein Team'
      }, null, 8, ["value"]),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (_unref(calculators).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(calculators), (calculator) => {
                return (_openBlock(), _createElementBlock("p", {
                  key: calculator.id,
                  class: "text-right"
                }, _toDisplayString(calculator.first_name + ', ' + calculator.last_name), 1))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_5, "Niemand"))
      ])
    ])
  ]))
}
}

})